// src/components/MemberRenewContainer/DependentsSection.jsx
import React from 'react';
import DependentsTable from './DependentsTable';

const DependentsSection = ({ dependents, setDependents, handleAddMember, updateMember, renewalProgress, selectedSecondWifeId, setSelectedSecondWifeId }) => {
  return (
    <div className="tw-bg-white tw-shadow-lg tw-rounded-xl tw-p-6 tw-mb-6 tw-border tw-border-gray-200">
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-6 tw-pb-4 tw-border-b tw-border-gray-200">
        <div className="tw-flex tw-items-center">
          <div className="tw-bg-purple-100 tw-p-2 tw-rounded-lg tw-mr-3">
            <svg className="tw-w-6 tw-h-6 tw-text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h2 className="tw-text-2xl tw-font-bold tw-text-gray-800">Beneficiaries</h2>
        </div>
        <button
          onClick={handleAddMember}
          className="tw-bg-gradient-to-r tw-from-green-500 tw-to-emerald-500 tw-text-white tw-px-5 tw-py-2.5 tw-rounded-lg tw-shadow-md hover:tw-shadow-lg tw-font-semibold tw-transition-all tw-duration-200 hover:tw-from-green-600 hover:tw-to-emerald-600 tw-flex tw-items-center"
        >
          <svg className="tw-w-5 tw-h-5 tw-mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Beneficiary
        </button>
      </div>
      <DependentsTable 
        renewalProgress={renewalProgress}
        dependents={dependents}
        setDependents={setDependents}
        updateMember={updateMember}
        selectedSecondWifeId={selectedSecondWifeId}
        setSelectedSecondWifeId={setSelectedSecondWifeId}
      />
    </div>
  );
};

export default DependentsSection;
